import Webcomponent from "../common/WebcomponentCreator"
import "../css/table.css"
import styles from "styles-to-js-loader/styles"

class TableBase extends Webcomponent {
    constructor(template, tableDiv = null) {
        super(template, { shadowMode: "closed" });
        this.tableContainer = document.createElement("div");
        this.tableContainer.className = "table-container";
        this.table = document.createElement("table");
        this.getShadow().appendChild(styles.get());
        this.template = template;
        this.tableContainer.appendChild(this.table);
        if (!tableDiv) {
            this.template.appendChild(this.tableContainer);
        }
        else {
            this.tableDiv = tableDiv;
            this.tableDiv.appendChild(this.tableContainer);
        }
        this.serieNameColumn = [];
        this.tableRows = [];
        this.headerCategories = [];

        window.addEventListener("resize", () => this.updateStickySecondColumnPosition());
    }

    updateStickySecondColumnPosition() {
        const shadowRoot = this.getShadow();
        const firstColumnCells = shadowRoot.querySelectorAll("thead th:first-child, tbody th:first-child");
        const secondColumnCells = shadowRoot.querySelectorAll("thead th.sticky-second-column, tbody td.sticky-second-column");

        if (firstColumnCells.length > 0) {
            // Calculate the width of the first column
            const firstColumnWidth = firstColumnCells[0].getBoundingClientRect().width;

            // Apply the calculated width to the left property of the second column
            secondColumnCells.forEach(cell => {
                cell.style.left = `${firstColumnWidth}px`;
            });
        }
    }

    //Serie structure:
    // serie: [
    //     {
    //         name: "Dalarna",
    //         data: [1,2,3]
    //     }
    // ]

    createPlaceholderTable() {
        this.table.innerHTML = '';

        const thead = document.createElement('thead');
        const trHead = document.createElement('tr');
        for (let i = 0; i < 4; i++) {
            const th = document.createElement('th');
            th.innerHTML = 'Hämtar data...';
            trHead.appendChild(th);
        }
        thead.appendChild(trHead);
        this.table.appendChild(thead);

        // Create tbody with placeholder rows
        const tbody = document.createElement('tbody');
        for (let i = 0; i < 10; i++) {
            const tr = document.createElement('tr');
            for (let j = 0; j < 4; j++) {
                const td = document.createElement('td');
                td.innerHTML = '...';
                tr.appendChild(td);
            }
            tbody.appendChild(tr);
        }
        this.table.appendChild(tbody);
    }

    createSpinner(div) {
        this.spinner = document.createElement('spinner-component');
        this.spinner.style.display = 'none';
        div.appendChild(this.spinner);
    }

    showSpinner(div) {
        if (!this.spinner) {
            this.createSpinner(div);
        }
        this.spinner.style.display = 'block';
    }

    hideSpinner() {
        this.spinner.style.display = 'none';
    }

    createTable(categories, series, shouldAddCaption = false, onlyUseDataArray = false, tdAlignCenter = true, stickySecondColumn = false) {
        if (categories.length <= 0) {
            console.error("Create data table: categories not an array or not set")
            if (this.spinner) {
                this.hideSpinner();
            }
            return;
        }
        if (series.length <= 0) {
            console.error("Create data table: data not an array or not set")
            if (this.spinner) {
                this.hideSpinner();
            }
            return;
        }
        const hasCompInfo = series.some(serie => serie.showMore);

        //Delete table
        this.table.innerHTML = null;
        if (shouldAddCaption)
            this.addCaption();
        //First create the top row containing categories..
        const thead = document.createElement("thead");
        this.table.appendChild(thead);
        const trHead = document.createElement("tr");
        thead.appendChild(trHead);

        for (let i = 0; i < categories.length; i++) {
            var th = document.createElement("th");
            th.setAttribute("scope", "col");
            th.innerHTML = categories[i];

            if (stickySecondColumn && i === 1) {
                th.classList.add("sticky-second-column");
            }

            trHead.appendChild(th);
            if (categories[i] !== "Region")
                this.headerCategories.push(th);
        }
        //Then create the table body containing serie data...
        const tbody = document.createElement("tbody");
        this.table.appendChild(tbody);
        for (let i = 0; i < series.length; i++) {
            var tr = document.createElement("tr");
            tbody.appendChild(tr);
            //Serie name, always first in the row
            if (!onlyUseDataArray) {
                var th = document.createElement("th");
                th.innerHTML = series[i].name;
                th.setAttribute("scope", "row");
                tr.appendChild(th);
                this.serieNameColumn.push(th);
            }
            //Fill out rest of the row with data...
            const datalength = hasCompInfo ? series[i].data.length + 1 : series[i].data.length;
            for (let j = 0; j < datalength; j++) {
                var tdData;
                if (onlyUseDataArray && j === 0) {
                    tdData = document.createElement("th");
                    tdData.setAttribute("scope", "row");
                    tdData.innerHTML = series[i].data[j];
                    this.serieNameColumn.push(tdData);
                } else if (hasCompInfo && j === series[i].data.length) {
                    tdData = document.createElement("td");
                    const button = document.createElement("button");
                    button.setAttribute("disabled", "true");
                    button.setAttribute("class", "complimentary-information-button");
                    button.innerHTML = '&#9207';
                    tdData.appendChild(button)
                }
                else {
                    tdData = document.createElement("td");
                    tdData.innerHTML = series[i].data[j];
                }

                if ((stickySecondColumn && j === 0) || (stickySecondColumn && onlyUseDataArray && j === 1) ) {
                    tdData.classList.add("sticky-second-column");
                }

                tdData.classList.add("left-align");


                if (series[i]?.systemChange?.[j] === true) {
                    tdData.classList.add("red-row");
                }

                tr.appendChild(tdData);
            }
            this.tableRows.push(tr);

            //If we have showMore, enable button on that row and display extra information
            if (series[i].showMore) {
                this.addComplimentaryInformationClick(tr, series, i, tbody);
            }
        }

        if (stickySecondColumn) {
            this.updateStickySecondColumnPosition();
        }

        if (this.spinner) {
            this.hideSpinner();
        }
    }
    //Redoing, remove old createTable later
    newCreateTable({ xNames, series, footer }) {
        this.showSpinner();

        if (xNames.length <= 0) {
            console.error("Create data table: categories not an array or not set")
            if (this.spinner) {
                this.hideSpinner();
            }
            return;
        }
        if (series.length <= 0) {
            console.error("Create data table: data not an array or not set")
            if (this.spinner) {
                this.hideSpinner();
            }
            return;
        }
        //Delete table
        this.table.innerHTML = null;
        //First create the top row containing categories..
        const thead = document.createElement("thead");
        this.table.appendChild(thead);
        const trHead = document.createElement("tr");
        thead.appendChild(trHead);
        for (let i = 0; i < xNames.length; i++) {
            var th = document.createElement("th");
            th.setAttribute("scope", "col");
            th.innerHTML = xNames[i];
            trHead.appendChild(th);
            if (xNames[i] !== "Region")
                this.headerCategories.push(th);
        }
        //Then create the table body containing serie data...
        const tbody = document.createElement("tbody");
        this.table.appendChild(tbody);
        //Create each row from series data
        for (let i = 0; i < series.length; i++) {
            var tr = document.createElement("tr");
            //Add name of each serie first
            var th = document.createElement("th");
            th.innerHTML = series[i].name;
            th.setAttribute("scope", "row");
            tr.appendChild(th);
            this.serieNameColumn.push(th);
            tbody.appendChild(tr);
            //Fill out rest of the row with data...
            var tdData;
            for (let j = 0; j < series[i].data.length; j++) {
                tdData = document.createElement("td");
                var val = series[i].data[j].y;
                if (val === -1)
                    val = "För få antal för att redovisas";
                else if (!val)
                    val = "-";
                tdData.innerHTML = val;
                tr.appendChild(tdData);
            }
            this.tableRows.push(tr);
        }
        //If footer, add it last
        if (footer) {
            var tfoot = document.createElement("tfoot");
            tfoot.innerHTML = footer;
            this.table.appendChild(tfoot);
        }
        if (this.spinner) {
            this.hideSpinner();
        }
    }

    //Adds a clickable function to the first column so filter can make a new search with the selected unit/region
    addFilterSearchOnClick(customEventName = "", callback = this.onColumnClickCallback) {
        this.serieNameColumn.forEach(col => {
            col.setAttribute("class", "clickable");
            col.addEventListener("click", function (e) {
                var value = this.innerHTML;
                callback(value, customEventName);
            });
        })
    }
    onColumnClickCallback(value, customEventName = "") {
        document.dispatchEvent(new CustomEvent(
            customEventName,
            {
                bubbles: true,
                composed: true,
                detail: value
            }
        ));
    }

    addComplimentaryInformationClick(tr, series, i, tbody) {
        tr.setAttribute("class", "complimentary-information");
        var button = tr.querySelector("button");
        button.removeAttribute('disabled')

        button.addEventListener("click", (e) => {

            // REMOVE
            if (button.getAttribute("showing")) {
                button.removeAttribute("showing");
                var row = tbody.getElementsByTagName("tr")[tr.rowIndex];
                tbody.removeChild(row);
                button.innerHTML = '&#9207';
            }
            // ADD INFORMATION
            else {
                button.setAttribute("showing", true);
                var compTr = tbody.insertRow(tr.rowIndex);
                compTr.setAttribute("class", "complimentary-information-row");

                series[i].showMore.forEach(sm => {
                    var compTd = document.createElement("td");
                    var compUl = document.createElement("ul");
                    var compLi = document.createElement("li");
                    var text = "<b>" + sm.name + "</b><br>";
                    // Lägg till länk till webbplatsen
                    if (sm.name === "Url") {
                        text += "<a href=\"https://" + sm.y + "\">" + sm.y + "</a>"
                    } else {
                        text += sm.y;
                    }
                    compLi.innerHTML = text;
                    compUl.appendChild(compLi);
                    compTd.appendChild(compUl);
                    compTr.appendChild(compTd);
                    button.innerHTML = '&#9206';
                });
            }
        });
    }

    //Adds a "title" 
    addCaption(text = "", cssClass = "") {
        if (!this.caption) {
            this.caption = document.createElement("caption");
        }
        this.caption.innerHTML = text;
        if (cssClass) {
            this.caption.className = cssClass;
        }
        this.table.appendChild(this.caption);
    }

    //Invisble title for screen readers
    addSummary(text) {
        this.table.setAttribute("summary", text)
    }
    /*
    Format: [{
        text: "Hej",
        span: 2
    }]
    */
    addDescriptiveTitles(titles = []) {
        var thead = document.createElement("thead");
        var row = document.createElement("tr");
        var emptyHeader = document.createElement("th");
        emptyHeader.colSpan = 1;
        thead.appendChild(row);
        row.appendChild(emptyHeader)
        for (var i = 0; i < titles.length; i++) {
            var titleHeader = document.createElement("th");
            titleHeader.innerHTML = titles[i].text;
            titleHeader.colSpan = titles[i].span;
            row.appendChild(titleHeader);
        }
        var firstChild = this.table.firstChild;
        this.table.insertBefore(thead, firstChild);
    }
    //Error
    errorNoData() {
        this.table.innerHTML = null;
        var thead = document.createElement("thead");
        var row = document.createElement("tr");
        var cell = document.createElement("td");
        cell.innerHTML = "Ingen data finns för gjort urval";
        row.appendChild(cell);
        thead.appendChild(row)
        this.table.appendChild(thead);
    }
}
export default TableBase;

